<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="card">
    <div class="body">
    <div class="col-lg-12">
      <exercises ref="exercise_child" :exercise="exercise" :engine="engine"></exercises>
      <br>
      <ValidationObserver ref="formValidation">
      <div class="row">
          <div class="col-md-4">
              <div class="mb-2 font-weight-bold">Configuración</div>
              <!--<div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.CALCULADORA"
                id="CALCULADORA">
                <label class="custom-control-label" for="CALCULADORA">Mostrar calculadora</label>
              </div>-->
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.SIMPLIFICAR_RESULTADO"
                id="SIMPLIFICAR_RESULTADO">
                <label class="custom-control-label" for="SIMPLIFICAR_RESULTADO">Simplificar resultado</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.REDONDEAR"
                id="REDONDEAR">
                <label class="custom-control-label" for="REDONDEAR">Redondear</label>
              </div>
          </div>
            <div class="col-md-4">
              <br/>
                Máximo decimales
                <b-form-input v-model="configuration.MAX_DECIMALES" type="number">
                </b-form-input>
            </div>
            <div class="col-md-4">
              <br/>
              Tipo aproximación<select class="form-control" v-model="configuration.APROXIMAR">
                <option value="0">Sin aproximación</option>
                <option value="1">Aproximación resultado</option>
                <option value="2">Aproximación operandos</option>
              </select>
              <div v-if="parseInt(configuration.APROXIMAR) !== 0">
                <br/>
                Nivel de aproximación
                <select class="form-control" v-model="configuration.NIVEL_APROXIMAR">
                  <option value="-5">Cienmilésimas</option>
                  <option value="-4">Diezmilésimas</option>
                  <option value="-3">Milésimas</option>
                  <option value="-2">Centésimas</option>
                  <option value="-1">Décimas</option>
                  <option value="0">Unidad</option>
                  <option value="1">Decena</option>
                  <option value="2">Centena</option>
                  <option value="3">U.millar</option>
                  <option value="4">D.millar</option>
                  <option value="5">C.millar</option>
                  <option value="6">U.millón</option>
                  <option value="7">D.millón</option>
                  <option value="8">C.millón</option>
                </select>
              </div>
            </div>
      </div>
      <br>
      <hr>
      <b-row>
        <b-col  style="text-align:center">
          <strong>Operaciones del ejercicio</strong>
          <b-button v-if="arrayEleOperation.length > 1" @click="removeArrayEleOperation()" class="btn btn-danger ml-2" size="sm">-</b-button>
          <b-button @click="addArrayEleOperation()" class="btn btn-primary ml-2" size="sm">+</b-button>
        </b-col>
      </b-row>
      <div>
        <div v-for="(operation, index) in arrayEleOperation" v-bind:key="index">
            <b-row class="justify-content-md-center" style="margin-bottom: 10px">
              <b-col col lg="8">
                <label>Enunciado</label>
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                    <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="arrayEleOperation[index].ENUNCIADOS_FORMULA_ID !== null && arrayEleOperation[index].ENUNCIADOS_FORMULA_ID !== 0"
                        @click="openResourceWithParam('statementformula', arrayEleOperation[index].ENUNCIADOS_FORMULA_ID)"/>
                    <input type="text" v-model="arrayEleOperation[index].ENUNCIADOS_FORMULA_NOMBRE"
                      disabled class="form-control" />
                    <searchstatementformula class="pl-2" v-bind:idModal="'mdlSearchEnunciado_'+index"
                      v-on:selected="onEnunciadoProblem($event, index)">
                    </searchstatementformula>
                  </div>
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
               <b-col col lg="4">
                <label>Unidad</label>
                  <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                    <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="arrayEleOperation[index].UNIDADR_ID !== null && arrayEleOperation[index].UNIDADR_ID !== 0"
                        @click="openResourceWithParam('unitmath', arrayEleOperation[index].UNIDADR_ID)"/>
                    <input type="text" v-bind:value="getTranslation(arrayEleOperation[index].UNIDADR_TEXTO)"
                      disabled class="form-control"/>
                    <searchunitmath class="pl-2" v-bind:idModal="'mdlSearchUnitMath_'+index"
                      v-on:selected="onSelectedUnitMath($event, index)">
                    </searchunitmath>
                  </div>
                  <!-- Special validation with hidden field ID, as the text may be empty and cause validation erross -->
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input type="text" v-bind:value="arrayEleOperation[index].UNIDADR_ID" style="display: none"/>
                    <span class="validation-error">{{ errors[0] }}</span>
                  </ValidationProvider>
              </b-col>
            </b-row>
            <b-row>
              <b-col col lg="6">
                <label>Formula</label>
                  <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                    <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="arrayEleOperation[index].FORMULAS_ID !== null && arrayEleOperation[index].FORMULAS_ID !== 0"
                        @click="openResourceWithParam('formulas', arrayEleOperation[index].FORMULAS_ID)"/>
                    <b-form-textarea
                      id="textarea"
                      disabled class="form-control"
                      v-model="arrayEleOperation[index].FORMULA_TEXTO"
                      placeholder="Fórmula..."
                      rows="5"
                      max-rows="5"
                      :readonly=true >
                    </b-form-textarea>
                  </div>
              </b-col>
              <b-col col lg="6">
                <label>Plantilla</label>
                  <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                    <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="arrayEleOperation[index].PLANTILLAS_ID !== null && arrayEleOperation[index].PLANTILLAS_ID !== 0"
                        @click="openResourceWithParam('templates', arrayEleOperation[index].PLANTILLAS_ID)"/>
                    <b-form-textarea
                      id="textarea"
                      disabled class="form-control"
                      v-bind:value="getTranslation(arrayEleOperation[index].PLANTILLA_TEXTO)"
                      placeholder="Plantilla..."
                      rows="5"
                      max-rows="5"
                      :readonly=true >
                    </b-form-textarea>
                  </div>
              </b-col>
            </b-row>
            <br />
            <b-row class="justify-content-md-center" v-if="arrayEleOperation[index].ENUNCIADOS_FORMULA_ELEMENTS.length > 0">
                <b-col col md="4">
                  <h6>Unidades</h6>
                </b-col>
                <b-col col md="4">
                  <h6>Cantidades</h6>
                </b-col>
            </b-row>
            <b-row v-if="arrayEleOperation[index].ENUNCIADOS_FORMULA_ELEMENTS.length > 0">
              <div style="width:100%" v-for="(ELEMENTO, idope) in arrayEleOperation[index].ENUNCIADOS_FORMULA_ELEMENTS" v-bind:key="idope">
                <b-row class="justify-content-md-center">
                  <b-col md="4" class="d-inline-flex align-items-center">
                    <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="arrayEleOperation[index].CU && ELEMENTO.UNIDADES_ID !== null"
                      @click="cleanUnitOPES(index, idope)"/>
                    <input type="text"
                      v-bind:id="'UNIDAD' + index + idope"
                      v-bind:value="getTranslation(ELEMENTO.RESPUESTAU_TEXTO)"
                      disabled class="form-control"/>
                    <searchunitmath class="pl-2" v-bind:idModal="'mdlSearchUnitMathOPES_'+index+idope" v-if="arrayEleOperation[index].CU"
                      v-on:selected="onSelectedUnitMathOPES($event, index, idope)" bButtonIcon="true">
                    </searchunitmath>
                  </b-col>
                  <b-col md="4">
                     <ValidationProvider rules="required" v-slot="{ errors }">
                        <b-form-input
                          :disabled="!arrayEleOperation[index].CC"
                          type="text"
                          v-bind:id="'CANTIDAD' + index + idope"
                          v-model="ELEMENTO.CANTIDAD"  />
                        <span class="validation-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <br>
              </div>
            </b-row>
            <br />
            <b-row  class="justify-content-md-center">
              <b-col col lg="3" style="text-align:center"><h6>Incorrecta 1</h6></b-col>
              <b-col col lg="3" style="text-align:center"><h6>Incorrecta 2</h6></b-col>
              <b-col col lg="3" style="text-align:center"><h6>Incorrecta 3</h6></b-col>
              <b-col col lg="3" style="text-align:center"><h6>Incorrecta 4</h6></b-col>
            </b-row>
            <b-row class="justify-content-md-center" style="margin-bottom: 10px">
              <b-col col lg="3">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-form-input type="text"
                    v-bind:id="'INC1' + index"
                    v-model="arrayEleOperation[index].INC1" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col col lg="3">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-form-input type="text"
                    v-bind:id="'INC2' + index"
                    v-model="arrayEleOperation[index].INC2" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col col lg="3">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-form-input type="text"
                    v-bind:id="'INC3' + index"
                    v-model="arrayEleOperation[index].INC3" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col col lg="3">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-form-input type="text"
                    v-bind:id="'INC4' + index"
                    v-model="arrayEleOperation[index].INC4" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
            </b-row>
            <hr/>
        </div>
      </div>
      <br>
      <b-row>
        <b-col class="text-center">
          <button v-on:click="saveStorage" :disabled="arrayEleOperation.length < 1" class="btn btn-info btn-lg">
          Guardar
        </button>
        </b-col>
      </b-row>
      </ValidationObserver>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import exercises from '../../exercises/exercise.vue';
import engineMixin from '../../../../mixins/engine';
import searchunitmath from '../../units/SearchUnitmath.vue';
import searchstatementformula from '../../statements/SearchStatementFormula.vue';
import translationMixin from '../../../../mixins/translation';


extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});

export default {
  props: {
    engine: Number,
    exercise: Object,
    type: String,
  },
  mixins: [engineMixin, translationMixin],
  components: {
    exercises,
    ValidationProvider,
    ValidationObserver,
    searchunitmath,
    searchstatementformula,
  },
  data() {
    return {
      arrayEleOperation: [],
      // Mapear con los campos de la tabla PROBSIMPLES_CONF
      configuration: {
        ID: -1,
        CALCULADORA: false,
        SIMPLIFICAR_RESULTADO: true,
        MAX_DECIMALES: 2,
        REDONDEAR: true, //
        APROXIMAR: 0, // [0] Sin aproximación [1] Aproximación resultado [2] Aproximación operandos
        NIVEL_APROXIMAR: 2,
        EJERCICIOS_ID: -1, //
      },
    };
  },
  methods: {
    removeArrayEleOperation() {
      this.arrayEleOperation.pop();
    },
    addArrayEleOperation() {
      this.arrayEleOperation.push({
        POSICION: this.arrayEleOperation.length + 1,
        INC1: null,
        INC2: null,
        INC3: null,
        INC4: null,
        ENUNCIADOS_FORMULA_ID: null,
        ENUNCIADOS_FORMULA_NOMBRE: null,
        UNIDADR_ID: null,
        UNIDADR_TEXTO: [],
        PLANTILLA_TEXTO: [],
        ENUNCIADOS_FORMULA_ELEMENTS: [],
        ENUNCIADOS_FORMULA_NUMELEMENTS: null,
      });
    },
    /**
    * @method saveStorage
    * @description Guarda los datos del formulario
    */
    saveStorage() {
      this.$refs.exercise_child.$refs.formValidation.validate().then((exerciseOK) => {
        if (!exerciseOK) {
          return;
        }

        this.$refs.formValidation.validate().then((success) => {
          if (!success) {
            return;
          }

          this.$nextTick(() => {
            this.$refs.exercise_child.active();
          });

          const { objexercise } = this.$refs.exercise_child;
          const elemntsoperation = [];
          this.arrayEleOperation.forEach((element) => {
            const values = [];
            element.ENUNCIADOS_FORMULA_ELEMENTS.forEach((value) => {
              values.push({
                POSICION: value.POSICION,
                CANTIDAD: value.CANTIDAD,
                UNIDADES_ID: value.UNIDADES_ID,
                PROBFORMULA_ELE_ID: value.ID,
                RESPUESTAU_TEXTO: value.RESPUESTAU_TEXTO,
              });
            });
            elemntsoperation.push({
              POSICION: element.POSICION,
              PROBFORMULA_CONF_ID: element.PROBFORMULA_CONF_ID,
              ENUNCIADOS_FORMULA_ID: element.ENUNCIADOS_FORMULA_ID,
              ENUNCIADOS_FORMULA_NOMBRE: element.ENUNCIADOS_FORMULA_NOMBRE,
              UNIDADR_ID: element.UNIDADR_ID,
              UNIDADR_TEXTO: element.UNIDADR_TEXTO,
              INC1: element.INC1,
              INC2: element.INC2,
              INC3: element.INC3,
              INC4: element.INC4,
              CC: element.CC,
              CU: element.CU,
              FORMULAS_ID: element.FORMULAS_ID,
              FORMULA_TEXTO: element.FORMULA_TEXTO,
              PLANTILLAS_ID: element.PLANTILLAS_ID,
              PLANTILLA_TEXTO: element.PLANTILLA_TEXTO,
              ENUNCIADOS_FORMULA_ELEMENTS: values,
            });
          });
          const motorData = {
            exercise: objexercise,
            configuration: this.configuration,
            elements: elemntsoperation,
            totalElements: this.arrayEleOperation.length,
          };

          let exerciseID = null;
          if (this.$props.exercise) {
            exerciseID = this.$props.exercise.ID;
          }
          if (exerciseID === null) { // Means there is no exercise created here, get tempID from storage
            const tempID = window.sessionStorage.getItem('tempEngineID');
            exerciseID = `tempID_${this.type}_${tempID}`;
          }
          console.log(`saveStorage: ${exerciseID}`);

          // Grabo los datos del motor
          window.sessionStorage.setItem(`engine_${this.type}_${exerciseID}`, JSON.stringify(motorData));

          // Cierro el modal
          this.$root.$emit('bv::hide::modal', `baseEngineModal_${this.type}`);
        });
      });
    },
    async getMotorData(id) {
      this.loading = true;

      try {
        const response = await this.axios.get('problemformula/getproblemformula', {
          params: {
            ejercicios_id: id,
          },
        });

        this.configuration = response.data.config;
        response.data.elements.forEach((element) => {
          this.arrayEleOperation.push({
            POSICION: element.POSICION,
            INC1: element.INC1,
            INC2: element.INC2,
            INC3: element.INC3,
            INC4: element.INC4,
            ENUNCIADOS_FORMULA_ID: element.ENUNCIADOS_FORMULA_ID,
            ENUNCIADOS_FORMULA_NOMBRE: element.ENUNCIADOS_FORMULA_NOMBRE,
            UNIDADR_ID: element.UNIDADR_ID,
            UNIDADR_TEXTO: element.UNIDADR_TEXTO,
            CC: element.CC,
            CU: element.CU,
            FORMULAS_ID: element.FORMULAS_ID,
            FORMULA_TEXTO: element.FORMULA_TEXTO,
            PLANTILLAS_ID: element.PLANTILLAS_ID,
            PLANTILLA_TEXTO: element.PLANTILLA_TEXTO,
            ENUNCIADOS_FORMULA_ELEMENTS: element.ENUNCIADOS_FORMULA_ELEMENTS,
          });
        });
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el ejercicio', { type: 'warning' });
      }

      this.loading = false;
    },
    onSelectedUnitMath(itemSelected, idOperation) {
      this.arrayEleOperation[idOperation].UNIDADR_ID = itemSelected.ID;
      this.arrayEleOperation[idOperation].UNIDADR_TEXTO = itemSelected.TEXTO_SINGULAR;
      this.$root.$emit('bv::hide::modal', `mdlSearchUnitMath_${idOperation}`);
    },
    onSelectedUnitMathOPES(itemSelected, idOperation, idope) {
      this.arrayEleOperation[idOperation].ENUNCIADOS_FORMULA_ELEMENTS[idope].UNIDADES_ID = itemSelected.ID;
      this.arrayEleOperation[idOperation].ENUNCIADOS_FORMULA_ELEMENTS[idope].RESPUESTAU_TEXTO = itemSelected.TEXTO_SINGULAR;
      this.$root.$emit('bv::hide::modal', `mdlSearchUnitMathOPES_${idOperation}${idope}`);
    },
    cleanUnitOPES(idOperation, idope) {
      this.arrayEleOperation[idOperation].ENUNCIADOS_FORMULA_ELEMENTS[idope].UNIDADES_ID = null;
      this.arrayEleOperation[idOperation].ENUNCIADOS_FORMULA_ELEMENTS[idope].RESPUESTAU_TEXTO = [];
    },
    /**
    * @method onEnunciadoProblem
    * @description Al buscar un enunciado
    */
    async onEnunciadoProblem(itemSelected, idOperation) {
      this.arrayEleOperation[idOperation].ENUNCIADOS_FORMULA_NOMBRE = itemSelected.NOMBRE;
      this.arrayEleOperation[idOperation].ENUNCIADOS_FORMULA_ID = itemSelected.ID;

      this.arrayEleOperation[idOperation].FORMULAS_ID = itemSelected.FORMULAS_ID;
      this.arrayEleOperation[idOperation].FORMULA_TEXTO = itemSelected.FORMULA_NOMBRE;
      this.arrayEleOperation[idOperation].PLANTILLAS_ID = itemSelected.PLANTILLAS_ID;

      this.arrayEleOperation[idOperation].CC = itemSelected.CC;
      this.arrayEleOperation[idOperation].CU = itemSelected.CU;

      // Obtener Elementos del recurso Problemas Formulas
      this.loading = true;
      try {
        const response = await this.axios.get('statementformula/getstamentformulaeles', {
          params: {
            id: itemSelected.ID,
          },
        });
        this.arrayEleOperation[idOperation].PLANTILLA_TEXTO = response.data.PLANTILLA_TEXTO;
        this.arrayEleOperation[idOperation].ENUNCIADOS_FORMULA_ELEMENTS = response.data.elements;
        this.arrayEleOperation[idOperation].ENUNCIADOS_FORMULA_NUMELEMENTS = response.data.elements.length;
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer elementos de la plantilla', { type: 'warning' });
      }
      this.loading = false;


      this.$root.$emit('bv::hide::modal', `mdlSearchEnunciado_${idOperation}`);
    },
  },
  async mounted() {
    if (this.exercise !== null && (this.exercise.ID !== null && this.exercise.ID !== undefined)) {
      await this.getMotorData(this.exercise.ID);
    }
    // Read from storage data
    this.readFromStorage(this.type);
    this.updatedNumOperation();
  },
};
</script>
